import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ShowIcon, HideIcon } from './styled';

const PasswordVisibilityToggle = ({
  visible, onToggle, className, id
}) => (
  <ToggleButton
    type="button"
    className={ className }
    onClick={ onToggle }
    id={ id }
    aria-label={ visible ? 'Hide password' : 'Show password' }
  >
    { visible ? <HideIcon /> : <ShowIcon /> }
  </ToggleButton>
);

PasswordVisibilityToggle.propTypes = {
  visible: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  id: PropTypes.string
};

PasswordVisibilityToggle.defaultProps = {
  className: '',
  id: ''
};

export default PasswordVisibilityToggle;
